import React from 'react';
import LeftContent from '../OTPPage/Children/leftContent';
import SignInPage from './childrens/signInPage';
import '../OTPPage/index.scss';

const EmployeSignIn = () => {

 return <div className="public_content">
    <div className="left_wrap"><LeftContent /></div>
    <div className="right_wrap"><SignInPage /></div>
 </div>    
};
export default EmployeSignIn;